import classNames from 'classnames';
import { FunctionComponent } from 'react';

interface OrganizationPageSectionTitleProps {
  title: string;
  className?: string;
}

const OrganizationPageSectionTitle: FunctionComponent<
  OrganizationPageSectionTitleProps
> = ({ title, className }) => {
  return (
    <h2 className={classNames('text-semibold block w-max text-xl', className)}>
      {title}
    </h2>
  );
};

export default OrganizationPageSectionTitle;
